// @flow
import _ from 'lodash'
import type { GoogleMap } from './google.map'

const defaultFillOpacity = 0.35
const brightFillOpacity = 0.6
const radiusMultiplier = 1000

export default class GoogleMapPoint {
  static pointIdCnt = 0

  onChangeFuncs: Array<(GoogleMapPoint) => void>
  onClickFuncs: Array<(GoogleMapPoint) => void>
  latitude: number
  longitude: number
  radius: number
  id: number
  name: string

  circle: any

  constructor(map: GoogleMap, longitude: number, latitude: number, radius: number, name: ?string) {
    this.onChangeFuncs = []
    this.onClickFuncs = []
    this.latitude = latitude
    this.longitude = longitude
    this.radius = radius
    this.id = GoogleMapPoint.pointIdCnt++
    this.name = name || ''

    this.circle = new window.google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: defaultFillOpacity,
      map: map,
      center: {
        lat: latitude,
        lng: longitude
      },
      radius: radius * radiusMultiplier,
      draggable: true,
      geodesic: true
    })

    this.circle.addListener('center_changed', () => {
      this.latitude = this.circle.getCenter().lat()
      this.longitude = this.circle.getCenter().lng()
      _.each(this.onChangeFuncs, (func) => func(this))
    })

    this.circle.addListener('click', () => {
      _.each(this.onClickFuncs, (func) => func(this))
    })
  }

  data() {
    return {
      longitude: this.longitude,
      latitude: this.latitude,
      radius: this.radius,
      name: this.name
    }
  }

  onChange(func: (GoogleMapPoint) => void) {
    this.onChangeFuncs.push(func)
  }

  onClick(func: (GoogleMapPoint) => void) {
    this.onClickFuncs.push(func)
  }

  eraseFromMap() {
    this.circle.setMap(null)
  }

  setRadius(radius: number) {
    this.radius = radius
    this.circle.setRadius(radius * radiusMultiplier)
  }

  useBrightView() {
    this.circle.setOptions({ fillOpacity: brightFillOpacity })
  }

  useDefaultView() {
    this.circle.setOptions({ fillOpacity: defaultFillOpacity })
  }

  setName(name: string) {
    this.name = name
  }
}

export type { GoogleMapPoint }
